import React, { useContext, useState } from 'react';
import Moment from 'moment';
import { Link, useHistory } from 'react-router-dom';
import { Container, Typography, Fab, Grid, Button, CircularProgress, Box } from '@mui/material';
import { green } from '@mui/material/colors';
import FieldActivityContext from '../contexts/FieldActivityContext';
import StopsContext from '../contexts/StopsContext';
import UserContext from '../contexts/UserContext';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import FieldActivityFinder from '../utils/updateHelper';
import FieldActivityClosureStatus from '../utils/FieldActivityClosureStatus';
import FieldActivityRemarks from '../utils/FieldActivityRemarks';
import { BottomNav } from './BottomNav';

const CameraIconButton = (props) => {

    //sticks it to top right
    const style = {
        margin: '8px',
        top: '0px',
        right: '0px',
        position: 'fixed',
        fontSize: '2.5rem',
        color: 'white',
        zIndex: 1000000,
        backgroundColor: 'transparent',
        boxShadow:'none'
    };

    return (
        <div>
            <Fab sx={style} component={Link} to="/photo-mode">
                <CameraAltOutlinedIcon />
            </Fab>
        </div>
    );
};

const ConfirmContainerNotOutBody = (props) => {

    const history = useHistory();

    const { fieldActivityId } = useContext(FieldActivityContext);
    const { stops, setStops } = useContext(StopsContext);
    const { currentUser } = useContext(UserContext);

    const [loading, setLoading] = useState(false);

    let faObj = stops.find(({FieldActivityId}) => FieldActivityId === fieldActivityId);

    let faClosureStatusCode = FieldActivityClosureStatus.CONTAINER_NOT_OUT;
    let faRemarkValue = FieldActivityRemarks.CONTAINER_NOT_OUT;

    let cnoCheck = false;
    //if we have an associated CRM SR we show the camera icon
    if (faObj.ServiceRequestNumber) {
        cnoCheck = true;
    }

    // let cnoPhotoExistsCheck = false;
    // //if we have an associated CRM SR and a photo has been taken
    // if(faObj.SharePointPhotoId && faObj.ServiceRequestNumber) {
    //     cnoPhotoExistsCheck = true;
    // }

    const handleClickNo = () => {
        history.goBack();
    };

    const goBackToRouteScreen = () => {
        history.go(-2);
    };

    const handleClickYes = () => {
        const now = Moment().format('MM/DD/YYYY h:mm A');
        setLoading(true);
        //update fa in app
        const newStops = [...stops];
        let faForUpdate = FieldActivityFinder(newStops, fieldActivityId);
        faForUpdate.update.FieldActivityRemark = props.selectionType;
        faForUpdate.update.FieldActivityRemarkValue = faRemarkValue;
        faForUpdate.update.DynamicsClosureStatus = faClosureStatusCode;
        faForUpdate.update.ModifiedDateTime = now;
        faForUpdate.update.CompletedDateTime = now;
        faForUpdate.update.Status = 'COMPLETED';
        faForUpdate.update.CompletedBy = currentUser;
        //Saved, Synced, ModifiedLocally?
        //faForUpdate.update.Saved = true;
        let logMessage = `Mobile App user ${currentUser} selected ${props.selectionType} at ${now}.`;
        faForUpdate.update.LogMessage = logMessage;

        //clear FI flag if necessry
        faForUpdate.update.ForemanInvestigateFlag = false;

        faForUpdate.update.NeedsToPostLog = true;
        faForUpdate.update.NeedsToUpdateCCB = true;

        //The unfortunate edge case...
        //True so that the dynamicsWorker can sort between calling the CNO flow for Dynamics entities or just CC&B FAs.
        faForUpdate.update.NeedsToUpdateDynamics = true;

        newStops[faForUpdate.index] = faForUpdate.update;
        setStops(newStops);

        setTimeout(function() {
            //setLoading(false);
            goBackToRouteScreen();
        }, 3000);

    };

    return (
        <React.Fragment>
            <Container maxWidth={false}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        justifyContent="center"
                        spacing={2}
                        style={{textAlign: 'center'}}
                    >
                        <Typography variant="h3" component="h2" gutterBottom style={{ marginTop: 100}}>
                            You have selected {props.selectionType}.
                        </Typography>
                        <Typography variant="h4" gutterBottom>
                            Is this correct?
                        </Typography>
                    </Grid>
                    <br />
                    <Grid
                        container
                        direction="column"
                        alignItems="center"
                        item xs={12}
                    >
                        {faObj.CnoPhoto &&
                            <img style={{width: '70%'}} src={faObj.CnoPhoto} alt="container not out" />
                        }
                        {cnoCheck &&
                            <CameraIconButton />
                        }
                    </Grid>
                    <Grid item xs={6} style={{textAlign: 'center'}}>
                        {loading && <CircularProgress size={50} sx={{ color: green[500], position: 'absolute', top: '50%', left: '50%', marginTop: "-12px", marginLeft: "-12px"}} />}
                    </Grid>
                </Box>
            </Container>
            <BottomNav>
                    <Button className={"secondary"}  component="a" onClick={handleClickNo}>NO</Button>
                    <Button className={"primary"} component="a" onClick={handleClickYes}>YES</Button>
            </BottomNav>
        </React.Fragment>
    );

};

export { ConfirmContainerNotOutBody };